// src/DAO.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import styled from 'styled-components';
import Navbar from '../components/Navbar';
import GlobalStyle from '../GlobalStyles';
import Footer from '../components/Footer';
import BannerWithCard_DAO from '../components/BannerWithCard_DAO';
import DAOSection2 from '../components/DAOSection2';
import DAOSection3 from '../components/DAOSection3';
import DAOSection4 from '../components/DAOSection4';
import DAOSection5 from '../components/DAOSection5';


const Container = styled.div`
  max-width: 100%;
  margin:0px;
  padding: 0px;
  background-color:#000000;
`;


function DAO() {



  return (

    <Container>
   
        <Navbar />
        <BannerWithCard_DAO /> 
        <DAOSection2 />
        <DAOSection3 />
        <DAOSection4 />
        <DAOSection5 />
        


        <Footer /> 

    </Container>

  );
}

export default DAO;